export default "/images/why_work_with_us/investor_confidence.png";